import { For, createMemo } from "solid-js";

type Props = {
  text: string;
  query: string;
};

/**
 * Wrap every case-insensitive occurrence of `query` inside `text` with
 * <mark>. Preserves the original casing of the text. Used to highlight
 * matched terms in search-result snippets.
 *
 * Empty / whitespace-only queries (and queries that don't appear in the
 * text) render the text as-is.
 */
export function HighlightMatch(props: Props) {
  const parts = createMemo(() => {
    const q = props.query.trim();
    if (!q) return [{ text: props.text, match: false }];
    const text = props.text;
    const ql = q.toLowerCase();
    const tl = text.toLowerCase();
    const out: { text: string; match: boolean }[] = [];
    let i = 0;
    while (i < text.length) {
      const idx = tl.indexOf(ql, i);
      if (idx === -1) {
        out.push({ text: text.slice(i), match: false });
        break;
      }
      if (idx > i) out.push({ text: text.slice(i, idx), match: false });
      out.push({ text: text.slice(idx, idx + q.length), match: true });
      i = idx + q.length;
    }
    return out;
  });

  return (
    <For each={parts()}>
      {(p) => (p.match ? <mark class="bg-warning/30 rounded-sm px-0.5">{p.text}</mark> : p.text)}
    </For>
  );
}
